import axios from "axios";

const API_URL = process.env.VUE_APP_ROULETTE_SOCKET_API;
const axiosSocketIns = axios.create({
  headers: {
    'Content-type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Content-Type',
    'cache-control': 'no-cache',
  },
  // You can add your headers here
  // ================================
  baseURL: API_URL,
  // timeout: 1000,

  validateStatus: function (status) {
    return status >= 200 && status < 500; // defecto
  },
});


let user = JSON.parse(localStorage.getItem('user'));
let token = localStorage.getItem('tokenSession');
if (user) {
  axiosSocketIns.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
}
if (token) {
  axiosSocketIns.defaults.headers.common['x-token'] = token;
  axiosSocketIns.defaults.headers.common['authentication-x-token'] = token;
}


export default axiosSocketIns;
